import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import reducer from './reducers';
import selectors from './selectors';

const options = {
  name: 'contractWorkloadBreakdown',
  baseType: 'CONTRACT_WORKLOAD_BREAKDOWN',
  apiEndpoint: 'contracts/{id}/workload_breakdown'
};

const operations = createMetadataAPIOperations(options);
export { operations, selectors };
export default reducer;
